import { Box, Stack } from "@mui/material";
import React from "react";
import orderNowBgImage from "../../Images/orderNowBgImg.png";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

const OrderNow = () => {
  return (
    <Stack width={"100%"} marginTop={"20px"} minHeight={"80vh"}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="start"
        padding={0}
        sx={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          padding: "10px",
          bgcolor: "#FE3B3E",
          gap: 2,
        }}
      >
        {Array.from({ length: 20 }).map((_, index) => (
          <Stack
            key={index}
            direction="row"
            alignItems="center"
            gap={2}
            sx={{
              whiteSpace: "nowrap",
            }}
          >
            <p
              style={{ fontWeight: 600, paddingX: "10px", fontSize: "20px", margin: 0 }}
            >
              ORDER NOW
            </p>
            <ShoppingCartOutlinedIcon sx={{ fontSize: "20px" }} />
          </Stack>
        ))}
      </Stack>
      <Stack
        sx={{
          backgroundImage: `url(${orderNowBgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "calc(80vh - 50px)",
          width: "100%",
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: "rgba(0, 0, 0, 0.5)",
          }}
        />
        <p style={{ textTransform: "uppercase", color: "white", fontSize: "60px", fontWeight: 700, zIndex: 1, width: "85%", textAlign: "center" }}>
          Everyday value in your pocket in as fast as 15 minutes.
        </p>
      </Stack>
    </Stack>
  );
};

export default OrderNow;
